import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';

const pluralize = require('pluralize');


export default class TimerNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Time Period';
        this.id = 'node_time_interval';
        this.icon = 'GiBackwardTime';
        this.linkedFeature = 'general';

        const settings: Setting[] = [
            // {
            //     id: 'NAME',
            //     name: 'Time Name',
            //     settingType: SettingType.NAME,
            //     required: true,
            //     default: 'Timer1S',
            // },
            {
                id: 'INTERVAL',
                name: 'Interval (seconds)',
                settingType: SettingType.NUMBER,
                required: true,
                max: 65535,
                min: 0.1,
                default: '1',
            },
        ];

        this.settings = this.settings.concat(settings);

        this.outputs = [
            {
                name: 'Tick',
                portId: 'timer_tick',
                params: [],
            },
        ];
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const project: ProjectConfiguration = this.project;
            const INTERVAL = this.getSettingValue('INTERVAL');
            return `Every ${INTERVAL} ${pluralize('second', Number(INTERVAL))}`;
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const INTERVAL = this.getSettingValue('INTERVAL');
        return `Every ${INTERVAL} ${pluralize('second', Number(INTERVAL))}`;
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `
This block triggers at the specified interval.`;
    }
}
